import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ApiHttpService } from '../../../services/api-http.service';
import { NotificationDto } from '../../../models';

// Notification types which represent partner vouchers (extend when new partners are added)
const VOUCHER_NOTIFICATION_TYPES = ['meiko_voucher'];

@Component({
  selector: 'cpf-vouchers-list',
  templateUrl: './vouchers-list.component.html',
  styleUrls: ['./vouchers-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VouchersListComponent implements OnInit {
  @Output() accountViewClicked = new EventEmitter<void>();
  @Output() contactUsClicked = new EventEmitter<void>();
  @Output() voucherDetailsClicked = new EventEmitter<NotificationDto>();

  vouchers: NotificationDto[] = [];
  loading = true;

  constructor(private apiHttpService: ApiHttpService,
              private router: Router) {
  }

  async ngOnInit() {
    try {
      const notifications = await this.apiHttpService.getUserNotifications();
      this.vouchers = (notifications || [])
        .filter(notification => VOUCHER_NOTIFICATION_TYPES.includes(notification.type))
        .sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime());
    } finally {
      this.loading = false;
    }
  }

  navigateAccount() {
    if (this.accountViewClicked.observed) {
      this.accountViewClicked.emit();
      return;
    }
    this.router.navigate(['calingo', 'account', 'view']);
  }

  navigateContactUs() {
    if (this.contactUsClicked.observed) {
      this.contactUsClicked.emit();
      return;
    }
    this.router.navigate(['calingo', 'account', 'contact-us']);
  }

  openVoucher(voucher: NotificationDto) {
    if (this.voucherDetailsClicked.observed) {
      this.voucherDetailsClicked.emit(voucher);
      return;
    }
    this.router.navigate(['calingo', 'account', 'vouchers', voucher.id]);
  }
}
